export default function MerchantDeleteModal({
  open, onClose, merchant, action, impact, confirmName, setConfirmName,
  reason, setReason, override, setOverride, onConfirm, deleting,
}) {
  if (!open || !merchant) return null;
  const isPurge = action === 'purge';
  const confirmDisabled =
    deleting
    || confirmName.trim().toLowerCase() !== (merchant.company_name || '').trim().toLowerCase()
    || reason.trim().length < 10
    || (impact?.has_blockers && !override);

  return (
    <div
      className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
      onClick={() => !deleting && onClose()}
    >
      <div
        className="bg-white rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`px-6 py-4 border-b ${isPurge ? 'bg-red-900' : 'bg-red-700'}`}>
          <h3 className="text-lg font-bold text-white">
            {isPurge ? '⚠️ Purgar Comercio Permanentemente' : 'Eliminar Comercio (Soft Delete)'}
          </h3>
          <p className="text-xs text-red-100">{merchant.company_name} · {merchant.email}</p>
        </div>
        <div className="p-6 space-y-4">
          {impact ? (
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 text-sm">
              <div className="font-semibold text-gray-900 mb-2">Impacto del borrado:</div>
              <div className="grid grid-cols-2 gap-2 text-xs text-gray-700">
                <div>📦 Proyectos: <span className="font-mono">{impact.summary.projects}</span></div>
                <div>🔑 API Keys: <span className="font-mono">{impact.summary.api_keys}</span></div>
                <div>🧾 Órdenes totales: <span className="font-mono">{impact.summary.orders_total}</span></div>
                <div>💰 Balance VES: <span className="font-mono">{impact.summary.balance_ves.toFixed(2)}</span></div>
              </div>
              {isPurge && (
                <div className="mt-2 text-xs text-red-700">
                  Las órdenes históricas se preservarán con <code className="bg-red-50 px-1">merchant_id=NULL</code> para auditoría.
                  Los proyectos, API keys, transferencias, wallets y webhooks <strong>se eliminan en cascada</strong>.
                </div>
              )}
              {!isPurge && (
                <div className="mt-2 text-xs text-orange-700">
                  Estado se cambia a <code className="bg-orange-50 px-1">deleted</code>. API keys revocadas. Reversible.
                </div>
              )}
            </div>
          ) : (
            <div className="text-sm text-gray-500">Cargando impacto...</div>
          )}

          {impact?.has_blockers && (
            <div className="bg-yellow-50 border border-yellow-300 rounded-lg p-3 text-sm">
              <div className="font-semibold text-yellow-900 mb-2">⚠️ Bloqueos detectados</div>
              {impact.blockers.map((b, i) => (
                <div key={`${b.type || b.message || 'blocker'}-${i}`} className="mb-2">
                  <div className="text-xs font-medium text-yellow-800">{b.message}</div>
                  {b.items && (
                    <div className="text-xs text-yellow-700 mt-1 max-h-32 overflow-y-auto">
                      {b.items.slice(0, 5).map((it, j) => (
                        <div key={it.order_code || it.id || `item-${i}-${j}`} className="font-mono">
                          {it.order_code || it.id?.substring(0, 8)} · {it.status} · {it.amount} {it.currency || 'VES'}
                        </div>
                      ))}
                      {b.items.length > 5 && <div className="italic">... y {b.items.length - 5} más</div>}
                    </div>
                  )}
                </div>
              ))}
              <label className="flex items-start gap-2 mt-2 cursor-pointer">
                <input
                  data-testid="delete-override"
                  type="checkbox"
                  checked={override}
                  onChange={(e) => setOverride(e.target.checked)}
                  className="mt-1"
                />
                <span className="text-xs text-yellow-900">
                  Acepto continuar a pesar de los bloqueos. Asumo la responsabilidad de los items en tránsito.
                </span>
              </label>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Motivo (mínimo 10 caracteres) *</label>
            <textarea
              data-testid="delete-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm"
              rows="2"
              placeholder="Describe brevemente la razón de esta eliminación (queda en el audit log)"
            />
            <div className="text-xs text-gray-500 mt-1">{reason.trim().length} caracteres</div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Para confirmar, escribe el nombre exacto:{' '}
              <code className="bg-gray-100 px-2 py-0.5 rounded text-red-700">{merchant.company_name}</code>
            </label>
            <input
              data-testid="delete-confirm-name"
              type="text"
              value={confirmName}
              onChange={(e) => setConfirmName(e.target.value)}
              className="w-full px-3 py-2 border-2 border-red-300 rounded-lg text-sm"
              placeholder={merchant.company_name}
            />
          </div>
        </div>
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-end gap-3">
          <button onClick={onClose} disabled={deleting} className="px-4 py-2 text-sm text-gray-600 border rounded-lg hover:bg-gray-100">
            Cancelar
          </button>
          <button
            data-testid="delete-confirm-btn"
            onClick={onConfirm}
            disabled={confirmDisabled}
            className={`px-4 py-2 text-sm text-white rounded-lg disabled:opacity-40 disabled:cursor-not-allowed ${
              isPurge ? 'bg-red-900 hover:bg-red-950' : 'bg-red-600 hover:bg-red-700'
            }`}
          >
            {deleting ? 'Eliminando...' : (isPurge ? 'Purgar Permanentemente' : 'Eliminar (Soft)')}
          </button>
        </div>
      </div>
    </div>
  );
}
